export default __webpack_public_path__ + "static/media/1593.583ade62.png";